import { Component, OnInit } from "@angular/core";
import { WorkingNotificationData } from "./working-notification.config";

@Component({
  selector: "app-worker-notification",
  templateUrl: "./working-notification.component.html",
  styleUrls: ["./working-notification.component.scss"],
})
export class WorkingNotificationComponent {
  constructor(public readonly data: WorkingNotificationData) {}
}
